import {getPreferredInstituteNumber} from 'app/components/instituteSelection/instituteCookies';
import {redirect} from 'app/components/instituteSelection/redirect';
import {type PreferredInstituteRedirectionConfig} from 'interfaces/georgestore/components/configuration/preferredinstituteredirection/preferredInstituteRedirectionConfig';

import {getGemSettingsFeature} from '../config/getGemSettingsFeature';
import {type GemSettings} from '../config/interface';
import {isClient} from '../isClient';

export const initPreferredInstitute = (gemSettings: GemSettings) => () => {
    if (!isClient()) {
        return false;
    }

    const instituteRedirectionConfig = getGemSettingsFeature<PreferredInstituteRedirectionConfig>(gemSettings, 'preferred-institute-redirection');
    if (!instituteRedirectionConfig) {
        return false;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const instituteNumberFromUrlParam = urlParams.get('institute');
    if (!instituteNumberFromUrlParam) {
        return false;
    }

    const currentPreferredInstituteNumber = getPreferredInstituteNumber();

    if (currentPreferredInstituteNumber?.includes(instituteNumberFromUrlParam)) {
        return false;
    }

    // institute number is with 3 digits in URL but GEM is using 4 digits (always prefixed with 0)
    const newPreferredInstituteNumber = `0${instituteNumberFromUrlParam}`;
    const instituteUrl = instituteRedirectionConfig.institutes[newPreferredInstituteNumber];
    if (instituteUrl) {
        redirect(newPreferredInstituteNumber, instituteUrl);
        return true;
    }

    return false;
};
